module.exports = __webpack_public_path__ + "img/rank_title.85068055.png";